import type { Resource } from '../../';
export const checkout_shipping_errors_cannotShipInternationally: Resource = {"default":"Sorry, we do not support international shipping yet. Please enter another address."};
